var cached;
var override;
function readLevelFromUrl() {
    var _a;
    if (typeof window === "undefined") {
        return "high";
    }
    var fromSearch = new URLSearchParams(window.location.search).get("quality");
    var hashQuery = (_a = window.location.hash.split("?")[1]) !== null && _a !== void 0 ? _a : "";
    var raw = fromSearch !== null && fromSearch !== void 0 ? fromSearch : new URLSearchParams(hashQuery).get("quality");
    return raw === "low" || raw === "mid" ? raw : "high";
}
export function qualitySettingsFor(level) {
    switch (level) {
        case "low":
            return { level: level, maxPixelRatio: 1, antialias: false };
        case "mid":
            return { level: level, maxPixelRatio: 1.5 };
        default:
            return { level: "high" };
    }
}
/** The quality settings requested by the URL, evaluated once. */
export function getQualitySettings() {
    if (override) {
        return override;
    }
    if (!cached) {
        cached = qualitySettingsFor(readLevelFromUrl());
    }
    return cached;
}
/** Test hook; production code reads the URL. */
export function setQualityOverride(settings) {
    override = settings;
}
